import * as React from 'react';

import {
  UitkDialog,
  UitkDialogContent,
  UitkDialogFooter,
  UitkDialogAnimationType,
  UitkDialogFooterButtonProps
} from 'uitk-react-dialog';

import { ActionType } from 'types/shared';
import { FlightsActionType, FlightsActionDisplayType } from '__generated__/api';

interface StaleSessionDialogProps {
  actions: ActionType[];
  animation: string;
  dialogId: string;
  header: string;
  message?: string;
  refreshSearch: () => void;
}

const getButtons = (actions: ActionType[], refreshSearch: () => void) => {
  return actions.map((action: ActionType) => {
    const button: UitkDialogFooterButtonProps = {
      onClick: action.type === FlightsActionType.REFRESH ? refreshSearch : null,
      text: action.displayAction,
      type: action.displayType === FlightsActionDisplayType.PRIMARY ? 'primary' : 'tertiary'
    };

    return button;
  });
};

export const StaleSessionDialog = ({
  actions,
  animation,
  dialogId,
  header,
  message,
  refreshSearch
}: StaleSessionDialogProps) => {
  const buttons = getButtons(actions, refreshSearch);

  return (
    <UitkDialog animation={UitkDialogAnimationType[animation]}>
      <div data-test-id="stale-session-dialog">
        <UitkDialogContent key={`${dialogId}-content`}>
          <h1 className="uitk-type-heading-600" key={`${dialogId}-header`}>
            {header}
          </h1>
          {message && (
            <p className="uitk-type-300" key={`${dialogId}-body`}>
              {message}
            </p>
          )}
        </UitkDialogContent>
        <UitkDialogFooter key={`${dialogId}-footer`} buttonOne={buttons[0]} buttonTwo={buttons[1]} />
      </div>
    </UitkDialog>
  );
};
